import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import { Subdomains } from "./Subdomains.js";
import "./index.css";

const root = document.getElementById("root");
if (!root) throw new Error("missing #root");

// Two pages, no router dependency — the Worker's SPA fallback serves index.html for
// /subdomains and we branch on the path once at mount.
const path = window.location.pathname.replace(/\/+$/, "");
const Page = path === "/subdomains" ? Subdomains : App;

createRoot(root).render(
  <StrictMode>
    <Page />
  </StrictMode>,
);
